import React, { useEffect } from "react";
import WorkerSupportTeam from "../../../Pages/Dashboard/Instances/Instances";
import CaseNotes from "./CaseNotes";

const CaseNotesTab = ({
  participantInfo,
  isCaseNoteCall,
  resetCaseNoteCall,
  setToggleState,
  callFrom = "participantProfile",
}) => {
  useEffect(() => {
    if (resetCaseNoteCall) {
      resetCaseNoteCall();
    }
  }, []);

  return (
    <>
      <div className='py-4 sm:py-6 px-4 sm:px-6 grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6'>
        <div
          className={
            callFrom === "silProfile"
              ? "lg:col-span-3"
              : "lg:col-span-2"
          }
        >
          <div className='bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden'>
            <CaseNotes
              callFrom={callFrom}
              isCaseNoteCall={isCaseNoteCall}
              participantInfo={participantInfo}
            />
          </div>
        </div>

        {callFrom !== "silProfile" && (
          <div className='lg:col-span-1'>
            <div className='bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6 supportTeam sticky top-24 flex flex-col max-h-[calc(100vh-8rem)]'>
              <div className='flex items-center gap-2 mb-4 pb-3 border-b border-gray-200 flex-shrink-0'>
                <div className='w-1 h-6 bg-gradient-to-b from-blue-500 to-cyan-500 rounded-full'></div>
                <h3 className='text-lg font-bold text-gray-900'>Support Team</h3>
              </div>
              <div className='flex-1 min-h-0'>
                <WorkerSupportTeam
                  callFrom={callFrom}
                  workers={
                    callFrom === "silProfile"
                      ? participantInfo?.workersList || []
                      : participantInfo?.sp_workers || []
                  }
                  setToggleState={setToggleState}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CaseNotesTab;
